import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  locale: string;
  width: string;
  height: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "AppInput",
  uniqId: "app_input",
})((theme, { params }, classes) => {
  return {
    formLabelControl: {
      width: params.width,
      height: params.height,

      "& .MuiFormLabel-asterisk": {
        color: "#FF3747",
        fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "200%",
        letterSpacing: params.locale === "en-US" ? 0 : "3.6px",
        textTransform: "uppercase",
      },

      "& .MuiTypography-root": {
        color: "#333",
        textAlign: "start",
        fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "200%",
        letterSpacing: params.locale === "en-US" ? 0 : "3.6px",
      },
    },
  };
});

export default useStyles;
